import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import css from './Sections.module.css';
import Icons from '../../../components/Icons/Icons';
import { fetchAllFaq, getFaq, getFaqInProgress } from '../../../ducks/strapi.duck';

const FAQSection = props => {
  const { intl } = props;
  const dispatch = useDispatch();
  const faqsRaw = useSelector(getFaq);
  const loading = useSelector(getFaqInProgress);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    dispatch(fetchAllFaq());
  }, [dispatch]);

  const faqs = useMemo(
    () =>
      (faqsRaw || []).map(item => ({
        id: item?.id ?? item?._id ?? Math.random(),
        question: item?.attributes?.question ?? item?.question ?? '',
        answer: item?.attributes?.answer ?? item?.answer ?? '',
        category:
          item?.attributes?.category?.data?.attributes?.name ?? item?.category?.name ?? null,
      })),
    [faqsRaw]
  );

  const handleAccordionClick = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className={css.faqContentWrapper}>
      <div className={css.contentWidth}>
        <div className={css.faqContent}>
          <div className={css.sectionHead}>
            <div className={css.leftSec}>
              <h2>
                {intl?.formatMessage?.({
                  id: 'FAQSection.title',
                  defaultMessage: 'Frequently Asked Questions',
                }) || 'Frequently Asked Questions'}
              </h2>
            </div>
          </div>

          {loading && (
            <div className={css.faqLoading}>
              {intl?.formatMessage?.({
                id: 'FAQSection.loading',
                defaultMessage: 'Loading FAQs…',
              }) || 'Loading FAQs…'}
            </div>
          )}
          {!loading && (!faqs || faqs.length === 0) && (
            <div className={css.faqEmpty}>
              {intl?.formatMessage?.({
                id: 'FAQSection.empty',
                defaultMessage: 'No FAQs available yet.',
              }) || 'No FAQs available yet.'}
            </div>
          )}

          {!loading && faqs?.length > 0 && (
            <div className={css.faqSection}>
              {faqs.map((faq, index) => (
                <div
                  key={faq.id || index}
                  className={classNames(css.faqCard, { [css.activeFAQ]: activeIndex === index })}
                  onClick={() => handleAccordionClick(index)}
                >
                  <div className={css.faqBody}>
                    <span className={css.faqHeading}>{faq.question}</span>
                    {activeIndex === index && (
                      <div
                        className={css.faqDescription}
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    )}
                  </div>
                  <span className={css.faqIcon}>
                    {activeIndex === index ? (
                      <span>
                        <Icons name="faqOpenIcon" />
                      </span>
                    ) : (
                      <span>
                        <Icons name="faqCloseIcon" />
                      </span>
                    )}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
